/* eslint-disable react/no-danger */
import { useContext } from 'react';
import t from 'react-translate';

import { css } from '@emotion/react';

import CollapsiblePanel from 'athena/components/collapsible-panel';
import { config } from '@config/pendo.config.json';
import { PanelStateKey } from 'athena/components/constants';
import MentoringProgramContext from '../../context';
import { primary } from 'styles/global_defaults/colors';

const styles = css`
  a {
    color: ${primary} !important;
  }
`;

const ProgramOrientation = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { orientation } = mentoringProgram || {};

  const panelTitle = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.ORIENTATION.TITLE();

  return (
    orientation && (
      <CollapsiblePanel
        title={panelTitle}
        ariaLabel={panelTitle}
        panelState={{ persistState: true, localStorageKey: PanelStateKey.PROGRAM_ORIENTATION_STATE }}
        dataQa={config.pendo.athena.mentorshipProgram.participantHome.orientation}
      >
        <div css={styles} className='mt-4'>
          <div
            /* TODO: I don't think we need this className. I didn't see it being used anywhere. */
            className='orientation'
            dangerouslySetInnerHTML={{
              __html: orientation,
            }}
          />
        </div>
      </CollapsiblePanel>
    )
  );
};

export default ProgramOrientation;
